<template>
  <div class="supproject mt30">
    <el-row class="contable">
      <el-col :span="24">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-gift fs14" /> Super Project Information</span>
          </div>
          <div>
            <el-form ref="form" :label-position="labelPosition" :model="form" label-width="200px">
              <el-form-item label="Super Project Name">
                <el-input v-model="form.sproject_name" :disabled="true"></el-input>
                <span class="help-block">English Super Project Name</span>
              </el-form-item>
              <el-form-item label="Super Project Label">
                <el-input v-model="form.sproject_label" :disabled="true"></el-input>
                <span class="help-block">English Super Project Label</span>
              </el-form-item>
              <el-form-item label="Super Project Description">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 6}" v-model="form.description" :disabled="true"></el-input>
                <span class="help-block">English description</span>
              </el-form-item>
              <el-form-item label="Institutions/Organizations">
                <el-input v-model="item.fullname_english" :disabled="true" v-for="(item, index) in institution" :key="index"></el-input>
                <span class="help-block">English name of Institutions/Organizations</span>
              </el-form-item>
              <el-form-item label="Grants">
                <el-table
                  empty-text="No Data"
                  border
                  :data="grantsData"
                  :show-overflow-tooltip="isOverflow"
                  style="width: 100%">
                  <el-table-column
                    prop="agency"
                    label="Agency"
                    :show-overflow-tooltip="isOverflow">
                  </el-table-column>
                  <el-table-column
                    prop="agency_abbr"
                    label="Grand Type"
                    width="200"
                    :show-overflow-tooltip="isOverflow">
                  </el-table-column>
                  <el-table-column
                    prop="grant_id"
                    label="Grant ID"
                    width="120"
                    :show-overflow-tooltip="isOverflow">
                  </el-table-column>
                  <el-table-column
                    prop="grant_title"
                    label="Grant Title"
                    :show-overflow-tooltip="isOverflow">
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
        <el-card class="box-card mt20" shadow="never">
          <div slot="header" class="clearfix">
            <span><i class="fa fa-cogs fs14" /> Show Super Project</span>
          </div>
          <div>
            Search: <el-input size="medium" v-model="searchkey" placeholder="" class="searchInput mr5" clearable></el-input>
            <el-button class="submitbtn" @click="handleSearch">Search</el-button>
            <el-table
              class="mt10"
              empty-text="No Data"
              border
              stripe
              height="500"
              v-loading="loading"
              :data="supData"
              style="width: 100%"
              :row-key="getRowKeys"
              @sort-change="handleSort"
              :expand-row-keys="expands"
              @expand-change="handleExpand">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-table
                    border
                    v-loading="subloading"
                    :data="props.row.subtableData"
                    style="width: 100%">
                    <!-- <el-table-column
                      prop=""
                      label=" "
                      width="50">
                    </el-table-column> -->
                    <el-table-column
                      prop="subtitle_en"
                      label="Subproject Title"
                      width="210"
                      :show-overflow-tooltip="isOverflow">
                      <template slot-scope="scope">
                        <span class="tablelink" @click="handlesubProurl(scope.row.subproject_id)">
                          {{scope.row.subtitle_en}}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="subproject_id"
                      label="Subproject ID">
                    </el-table-column>
                    <el-table-column
                      prop="px_id"
                      label="PXID">
                    </el-table-column>
                    <el-table-column
                      prop="species"
                      label="Species">
                    </el-table-column>
                    <el-table-column
                      prop="instrument"
                      label="Instrument"
                      :show-overflow-tooltip="isOverflow">
                    </el-table-column>
                    <el-table-column
                      prop="fileCount"
                      label="File Count (size)">
                    </el-table-column>
                    <el-table-column
                      prop="submit_time"
                      label="Release Date">
                    </el-table-column>
                  </el-table>
                </template>
              </el-table-column>
              <el-table-column
                label="Project Title"
                prop="project_title_english"
                width="200"
                sortable
                :show-overflow-tooltip="isOverflow">
                <template slot-scope="scope">
                  <span class="tablelink" @click="handleProurl(scope.row.project_id)">
                    {{scope.row.project_title_english}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="ProjectID"
                prop="project_id"
                width="122"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="PXID"
                prop="px_id"
                width="98"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Publication"
                prop="pubmed_id"
                sortable
                :show-overflow-tooltip="isOverflow">
                <template slot-scope="scope">
                  <span>
                    <a :href="publictionUrl+scope.row.pubmed_id" target="_blank">{{scope.row.pubmed_id}}</a>
                    {{scope.row.reference}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="Submitter"
                prop="submitter"
                width="114"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Lab Head"
                prop="lab_header"
                width="120"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Institution"
                prop="institution_english"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Subproject Count"
                prop="sub_count"
                width="100"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
              <el-table-column
                label="Releasedate"
                prop="submit_time"
                width="130"
                sortable
                :show-overflow-tooltip="isOverflow">
              </el-table-column>
            </el-table>
            <el-pagination
              background
              layout="total, prev, pager, next"
              :total="allNum"
              :page-size="pageSize"
              @current-change="handleChangepage"
              class="pagination mb10">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>   
  </div>
</template>

<script>
  import { getSuperProjectAll, getSearchProjectList, getSearchSubProjectList } from '@/api'
  export default {
    name: 'supproject',
    data() {
      return {
        labelPosition: 'right',
        form: {
          sproject_name: '',
          sproject_label: '',
          description: '',
          subtableData: []
        },
        institution: [],
        grantsData: [],
        supData: [],
        ajax_data: {
          search: {
            superproject_id: ''
          }
        },
        allNum: 0,
        pageSize: 5,
        searchkey: '',
        loading: true,
        isOverflow: true,
        orderConvert: {
          ascending: 'asc',
          descending: 'desc'
        },
        ajax_data_sup: {
          search:{
            superproject_id: '',
            sub: ""
          },
          page:{
            startPage: 1,
            pageLength: 20
          },
          order:{
            item: "",
            type: ""
          }
        },
        publictionUrl: 'http://www.ncbi.nlm.nih.gov/pubmed?term=',
        subloading: true,
        expands: [],
        getRowKeys (row) {
          return row.project_id
        },
        ajax_dataExpsubpro: {
          search:{
            project_id: "",
            sub: ""
          },
          page:{
            startPage: 1,
            pageLength: 0
          },
          order:{
            item: "",
            type: ""
          }
        }
      }
    },
    mounted() {
      if( this.$route.query.id && this.$route.query.id != '' ){
        this.ajax_data.search.superproject_id = this.$route.query.id
        getSuperProjectAll(this.ajax_data).then(res => {
          let resData = res.result[0]
          this.form = resData.basic[0]
          this.institution = resData.institution
          this.grantsData = resData.grant
        })
        this.ajax_data_sup.search.superproject_id = this.$route.query.id
        getSearchProjectList(this.ajax_data_sup).then(res => {
          this.loading = false
          this.supData = res.result
          this.allNum = res.count
        })
      }
    },
    created() {
      
    },
    methods: {
      handleProurl(param) {
        let routerData = this.$router.resolve({path: '/project', query: {id: param}})
        window.open(routerData.href, '_blank')
      },
      handlesubProurl(param) {
        let routerData = this.$router.resolve({path: '/subproject', query: {id: param}})
        window.open(routerData.href, '_blank')
      },
      onSubmit() {},
      handleChangepage (val) {
        this.loading = true
        this.ajax_data_sup.page.startPage = val
        getSearchProjectList(this.ajax_data_sup).then(res => {
          this.loading = false
          let newData = res.result
          newData.forEach((val, index) => {
            let fileCount = val.file_count;
            let fileSize = this.handleFilesize(val.file_size)
            val.fileCount = fileCount + fileSize
          })
          this.supData = newData
          this.allNum = res.count
        })
      },
      handleSearch() {
        this.loading = true
        this.ajax_data_sup.search.superproject_id = this.$route.query.id
        this.ajax_data_sup.search.sub = this.searchkey
        getSearchProjectList(this.ajax_data_sup).then(res => {
          this.loading = false
          let newData = res.result
          newData.forEach((val, index) => {
            let fileCount = val.file_count;
            let fileSize = this.handleFilesize(val.file_size)
            val.fileCount = fileCount + fileSize
          })
          this.supData = newData
          this.allNum = res.count
        })
      },
      handleSort (column, prop, order) {
        // console.log(column, prop, order)
        this.loading = true
        this.ajax_data_sup.order.item = column.prop
        this.ajax_data_sup.order.type = this.orderConvert[column.order]
        if (column.order !== null && column.prop !== null) {
          getSearchProjectList(this.ajax_data_sup).then(res => {
            this.loading = false
            let newData = res.result
            newData.forEach((val, index) => {
              let fileCount = val.file_count;
              let fileSize = this.handleFilesize(val.file_size)
              val.fileCount = fileCount + fileSize
            })
            this.subproData = newData
            this.allNum = res.count
          })
        } else {
          this.loading2 = false
        }
      },
      handleExpand(row, expandedRows) {
        this.subloading = true
        // console.log(row, expandedRows)
        this.expands = []
        if (expandedRows.length) {
          expandedRows.map((item, key) => {
            this.expands.push(item.project_id)
          })
          this.ajax_dataExpsubpro.search.project_id = row.project_id
          this.ajax_dataExpsubpro.search.sub = this.subprosekey
          this.ajax_dataExpsubpro.page.startPage = 1
          getSearchSubProjectList(this.ajax_dataExpsubpro).then(res => {
            this.subloading = false
            let newData = res.result
            newData.forEach((val, index) => {
              let fileCount = val.file_count;
              let fileSize = this.handleFilesize(val.file_size)
              val.fileCount = fileCount + fileSize
            })
            let subList = newData
            // console.log(subList)
            row.subtableData = subList
          })
        } else {
          this.expands = []
        }
      },
      handleFilesize(param) {
        let fileSize = param;
        if (fileSize == 0 || fileSize == null) {
          fileSize = ' (' + 0 +'K)';
        } else if (fileSize < 1024) {
          fileSize = ' (' + fileSize.toFixed(2) + 'K)';
        } else if (fileSize >= 1024 && fileSize < 1024 * 1024) {
          fileSize =  ' (' + (fileSize / 1024).toFixed(2)+ 'M)'
        } else {
          fileSize =   ' ('
            + (fileSize / 1024 / 1024).toFixed(2)
            + 'G)'
        }
        return fileSize
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .supproject {
  }
</style>
